import { render, staticRenderFns } from "./index.vue?vue&type=template&id=66572d38"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66572d38')) {
      api.createRecord('66572d38', component.options)
    } else {
      api.reload('66572d38', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=66572d38", function () {
      api.rerender('66572d38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/MentalEduConstruct/ConsultingRoom/index.vue"
export default component.exports